const isLocal = window.location.hostname === 'localhost';

export const BASE_URL = isLocal
  ? 'http://localhost:30021'
  : 'https://ddsecurity.co.kr/api';

export const BASE_URL2 = isLocal
    ? 'http://localhost:30022'
    : 'https://ddsecurity.co.kr/30022';
